// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import OrganizationsPage from '../screens/OrganizationsPage';
import NewOrganizationPage from '../screens/NewOrganizationPage';
import SitesPage from '../screens/SitesPage';
import NewSitePage from '../screens/NewSitePage';
import PlaceholderPage from '../screens/PlaceholderPage';

/**
 * Every route in the app. Unlike Admin Center, this build owns its origin, so
 * paths are root-relative with no mount prefix to strip.
 */
export default function ProvisioningRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/organizations" replace />} />
      <Route path="organizations" element={<OrganizationsPage />} />
      <Route path="organizations/new" element={<NewOrganizationPage />} />
      <Route path="organizations/:orgId/sites" element={<SitesPage />} />
      <Route path="organizations/:orgId/sites/new" element={<NewSitePage />} />
      <Route path="runs" element={<PlaceholderPage title="Runs" />} />
      <Route path="runs/:runId" element={<PlaceholderPage title="Provisioning run" />} />
      <Route path="sites/:siteId" element={<PlaceholderPage title="Site detail" />} />
      <Route path="*" element={<Navigate to="/organizations" replace />} />
    </Routes>
  );
}
